import { VitalsRange } from "@/types/vitals";

// System defaults used whenever a member hasn't customized their range yet
// (TrackingConfig.ranges stays sparse until EditRangeModal's "custom range"
// flow is used) — without these, BP/Glucose readings would never flag as
// abnormal for members who never opened that screen.
export const DEFAULT_BP_RANGE: {
  systolic: [number, number];
  diastolic: [number, number];
} = {
  systolic: [90, 140],
  diastolic: [60, 90],
};

export const GLUCOSE_DEFAULT_RANGES: Partial<
  Record<keyof VitalsRange, [number, number]>
> = {
  fasting: [70, 99],
  postPrandial: [70, 139],
  random: [70, 139],
  beforeBed: [80, 140],
};

export function getBpRange(range: VitalsRange | undefined): {
  systolic: [number, number];
  diastolic: [number, number];
} {
  return {
    systolic: range?.systolic ?? DEFAULT_BP_RANGE.systolic,
    diastolic: range?.diastolic ?? DEFAULT_BP_RANGE.diastolic,
  };
}

export function getGlucoseRange(
  category: string | undefined,
  range: VitalsRange | undefined
): [number, number] | undefined {
  const key = (
    category === "fasting" || category === "Fasting"
      ? "fasting"
      : category === "postPrandial" || category === "Post-prandial"
      ? "postPrandial"
      : category === "beforeBed" || category === "Before bed"
      ? "beforeBed"
      : "random"
  ) as keyof typeof GLUCOSE_DEFAULT_RANGES;
  const stored = range?.[key] as [number, number] | undefined;
  if (Array.isArray(stored) && stored.length >= 2) return stored;
  return GLUCOSE_DEFAULT_RANGES[key];
}
